import { Avatar, Link, SxProps, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GoLeft } from 'Images';

interface ILinkArrowLeft {
  text: string;
  href: string;
  sx?: SxProps;
  textSx?: SxProps;
  newWindow: boolean;
}

export const LinkArrowLeft = ({
  text,
  href,
  sx,
  textSx,
  newWindow = true,
}: ILinkArrowLeft) => {
  const navigate = useNavigate();

  const hrefHandler = () => {
    newWindow ? window.open(href) : navigate(href);
  };

  return (
    <Link
      tabIndex={0}
      onClick={hrefHandler}
      sx={{
        width: 'max-content',
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 400,
          ...textSx,
        }}
      >
        {text}
      </Typography>
      <Avatar
        alt=''
        src={GoLeft}
        sx={{
          width: '17px',
          height: '17px',
        }}
      />
    </Link>
  );
};
